import {
  instance as axios,
  setJwtToken,
  // setMultiPartHeader,
} from "../../config/axiosInstance";

// ---------------------category-listing--------------------------
export const highStockListApi = async (data) => {
  const endPoint = `/admin/product/high/stock?${new URLSearchParams({ ...data, })}`;
  return await axios.get(endPoint, setJwtToken());
};
